import React from 'react';
import { useMicrophone } from '../../contexts/MicrophoneContext';
import useHangup from '../../hooks/useHangup';

const MicrophonePermissionUI = ({ onHangup }) => {
  const hangup = useHangup({ source: 'microphone_permission' });
  const { permissionState, isRequesting } = useMicrophone();

  // Show loading state if microphone permission is being requested
  if (permissionState === 'unknown' || permissionState === 'prompt' || isRequesting) {
    return (
      <>
        <style>{`
          @keyframes modalSlideIn {
            from {
              opacity: 0;
              transform: translate(-50%, -50%) scale(0.8);
            }
            to {
              opacity: 1;
              transform: translate(-50%, -50%) scale(1);
            }
          }
          .microphone-permission-modal {
            animation: modalSlideIn 0.3s ease-out;
          }
        `}</style>
        <div 
          className="microphone-permission-modal"
          style={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            background: 'rgba(0, 0, 0, 0.9)',
            color: 'white',
            padding: '30px',
            borderRadius: '15px',
            textAlign: 'center',
            zIndex: 1000,
            minWidth: '400px',
            maxWidth: '600px',
            backdropFilter: 'blur(10px)',
            boxShadow: '0 20px 40px rgba(0, 0, 0, 0.3)'
          }}
        >
        <p style={{ marginBottom: '20px', lineHeight: '1.5' }}>
          Please allow microphone access to continue with the phone call.
        </p>
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          marginTop: '20px'
        }}>
          <div style={{
            width: '20px',
            height: '20px',
            border: '2px solid #ffffff',
            borderTop: '2px solid transparent',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
            marginRight: '10px'
          }}></div>
          <span>Waiting for permission...</span>
        </div>
        </div>
        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </>
    );
  }

  // Show error if microphone permission is not granted
  if (permissionState === 'denied') {
    return (
      <>
        <style>{`
          @keyframes modalSlideIn {
            from {
              opacity: 0;
              transform: translate(-50%, -50%) scale(0.8);
            }
            to {
              opacity: 1;
              transform: translate(-50%, -50%) scale(1);
            }
          }
          .microphone-permission-modal {
            animation: modalSlideIn 0.3s ease-out;
          }
        `}</style>
        <div 
          className="microphone-permission-modal"
          style={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            background: 'rgba(0, 0, 0, 0.9)',
            color: 'white',
            padding: '30px',
            borderRadius: '15px',
            textAlign: 'center',
            zIndex: 1000,
            minWidth: '400px',
            maxWidth: '600px',
            backdropFilter: 'blur(10px)',
            boxShadow: '0 20px 40px rgba(0, 0, 0, 0.3)'
          }}
        >
        <p style={{ marginBottom: '20px', lineHeight: '1.5' }}>
          Microphone access is required for the phone call. 
          Please enable microphone access in your browser settings and try again.
        </p>
        <button 
          onClick={() => hangup({ reason: 'permission_denied' })}
          style={{
            background: '#8B0000',
            color: 'white',
            border: 'none',
            padding: '12px 24px',
            borderRadius: '6px',
            cursor: 'url("/icons/pointer.svg") 10 0, pointer',
            fontSize: '14px',
            fontWeight: 'bold',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px',
            margin: '0 auto',
            transition: 'background-color 0.2s ease'
          }}
          onMouseEnter={(e) => {
            e.target.style.background = '#A52A2A';
          }}
          onMouseLeave={(e) => {
            e.target.style.background = '#8B0000';
          }}
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" fill="white"/>
          </svg>
          Hang Up
        </button>
        </div>
      </>
    );
  }

  // Don't render anything if permission is granted
  return null;
};

export default MicrophonePermissionUI;
